import {AfterViewInit, Component, TemplateRef, ViewChild} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTimepickerModule} from '@angular/material/timepicker';
import {FieldTypeConfig, FormlyModule} from '@ngx-formly/core';
import {FieldType} from '@ngx-formly/material';

@Component({
  imports: [MatTimepickerModule, ReactiveFormsModule, FormlyModule, MatInputModule, MatFormFieldModule],
  template: `<input
      matInput
      [id]="id"
      [name]="field.name"
      [formControl]="formControl"
      [matTimepicker]="picker"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder"
      [tabindex]="props.tabindex"
      [readonly]="props.readonly"
      [required]="props.required"
    />
    <ng-template #timepickerToggle
      ><mat-timepicker-toggle (click)="detectChanges()" [disabled]="props.disabled" matIconSuffix [for]="picker"
    /></ng-template>
    <mat-timepicker #picker />`,
  styles: ``,
})
export class FormlyFieldTimepickerComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {
  @ViewChild('timepickerToggle', {static: true}) timepickerToggle!: TemplateRef<any>;
  ngAfterViewInit(): void {
    this.props['suffix'] = this.timepickerToggle;
    if (!this.props.description && !this.props['hintStart'] && !this.props['hintEnd'])
      this.props['hintEnd'] =
        'Displayed in ' +
        Intl.DateTimeFormat(undefined, {timeZoneName: 'longGeneric'})
          .formatToParts(new Date())
          .find(part => part.type == 'timeZoneName').value;
  }
  detectChanges() {
    this.options.detectChanges?.(this.field);
  }
}
